<template>
  <datatable :type="'news'" :rowData="news" :loadingMessage="loadingMessage" :noRowsMessage="noRowsMessage" :columns="columns"
             :paginationSize="50"></datatable>
</template>

<script>
import datatable from "datatables/datatable";

export default {
  name: 'all_news',
  components: {
    datatable,
    'publishedComponent': {
      name: 'publishedComponent',
      data() {
        return {
          saving: false,
        };
      },
      computed: {
        isAuthor() {
          return this.params.data.author_id === this.$store.state.auth.me.id;
        },
      },
      template: `
        <div class="col-12">
          
          <button v-if="params.data.published === false && isAuthor" 
                  class="btn orcaBtn bg-success" 
                  @click="publishedNews" 
                  :disabled="saving">
            <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i></span>
            <span v-else><i class="far fa-hand-point-right"></i></span>
          </button>
          
          <span v-else-if="!isAuthor && params.data.published === false" 
                class="text-danger">
            Only the author can click publish.
          </span>
          
          <span class="text-success" 
                v-else-if="params.data.published === true && params.data.authorised === true">
            Live On Website
          </span>
          
          <span class="text-success" 
                v-else-if="params.data.published === true && params.data.authorised === false">
            Ready for Auth
          </span>
          <span class="text-warning" v-else>...</span>
        </div>
      `,
      methods: {
        publishedNews() {
          if (!this.isAuthor) {
            this.$snotify.error('Only the author can publish this news article.');
            return;
          }
          
          this.saving = true;
          let paramsNews = {
            ...this.params.data,
            published: 1, 
          };

          axios.patch(this.crmApiPath + 'news/' + this.params.data.id, paramsNews)
            .then(() => {
              this.params.data.published = true;
              this.$snotify.success('News Article Updated');
              
              axios.patch(this.crmApiPath + 'news/website/save/' + this.params.data.id)
                .then(() => {
                  this.$snotify.success('News Article Updated on web');
                })
                .catch(error => {
                  console.log(error);
                  this.$snotify.error('Error updating news article');
                  this.saving = false;
                });
                
            })
            .catch(error => {
              console.log(error);
              this.$snotify.error('Error updating news article');
              this.saving = false;
            });
        }
      }
    },
    'authorisedComponent': {
  name: 'authorisedComponent',
  data() {
    return {
      saving: false
    };
  },
  computed: {
    canAuthorize() {
      // Check if the user has the permission and is not the author of the article
      const isAuthor = this.params.data.author_id === this.$store.state.auth.me.id;
      return this.$store.state.auth.me.permissions.includes('news_articles_set_publish');
    }
  },
  template: `
    <div class="col-12" v-if="params.data.published === true">
      <button v-if="canAuthorize && params.data.authorised === false" 
              class="btn orcaBtn bg-primary" 
              @click="confirmAuthorise" 
              :disabled="saving">
        <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i></span>
        <span v-else><i class="far fa-hand-point-right"></i></span>
      </button>
      
      <span class="text-primary" v-else-if="params.data.authorised === true">{{params.data.users_authorised_name}}</span>

      <span v-else-if="!canAuthorize" class="text-danger">You don't have permission</span>

      <span class="text-warning" v-else>Author must click publish first</span>
    </div>
    <span v-else>Author must click publish first</span>
  `,
  methods: {
    confirmAuthorise() {
      const confirmation = confirm('Are you sure you want to authorize this article? It will then be visible on the website.');
      if (confirmation) {
        this.authorisedNews();
      }
    },
    authorisedNews() {
      if (!this.canAuthorize) {
        this.$snotify.error('You do not have permission to authorize this news article.');
        return;
      }

      this.saving = true;
      let paramsNews = {
        ...this.params.data,
        authorised: 1, 
        authorised_by_id: this.$store.state.auth.me.id,
      };

      axios.patch(this.crmApiPath + 'news/' + this.params.data.id, paramsNews)
        .then(response => {
          this.params.data.authorised = response.data.authorised;
          this.params.data.users_authorised_name = response.data.authorised_by.first_name + ' ' + response.data.authorised_by.surname;
          this.$snotify.success('News Article Updated');
          
          axios.patch(this.crmApiPath + 'news/website/save/' + this.params.data.id)
            .then(() => {
              this.$snotify.success('News Article Updated on web');
            })
            .catch(error => {
              console.error(error);
              this.$snotify.error('Error updating news article on web');
              this.saving = false;
            });

          this.saving = false;
        })
        .catch(error => {
          console.error(error);
          this.$snotify.error('Error updating news article');
          this.saving = false;
        });
    }
  }
},
    'editComponent': {
      name: 'editComponent',
      data() {
        return {
          saving: false
        }
      },
      template: `
        <div class="col-12">
          <button class="btn orcaBtn" @click="editedNews" >
            <span><i class="fas fa-pencil-alt"></i></span>
          </button>
        </div>
      `,
      methods: {
        editedNews() {
          
          this.$store.commit('CURRENT_EDIT_NEWS_ARTICLE_ID', this.params.data.id);
          this.$nextTick(() => {
            // this.close_right_info();
            this.$router.push('/news/edit');
            this.$tabs.refresh('/news/edit', true)
          });

        }
      }
    },
    'viewComponent': {
      name: 'viewComponent',
      template: `
        <div class="col-12">
          <button class="btn orcaBtn bg-info" @click="viewNews">
            <span><i class="fas fa-eye"></i></span>
          </button>
        </div>
      `,
      methods: {
        viewNews() {
          this.$store.commit('CURRENT_EDIT_NEWS_ARTICLE_ID', this.params.data.id);
          this.$nextTick(() => {
            this.$router.push('/news/view');
            this.$tabs.refresh('/news/view', true)
          });
        }
      }
    },
    'deleteComponent': {
      name: 'deleteComponent',
      data() {
        return {
          saving: false
        }
      },
      template: `
        <div class="col-12">
          <button class="btn orcaBtn bg-danger" @click="deletedNews" :disabled="saving">
            <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i></span>
            <span v-else><i class="fas fa-trash-alt"></i></span>
          </button>
        </div>
      `,
      methods: {
        deletedNews() {
          this.saving = true;

          let paramsNews = {
            ...this.params.data,
          };

          axios.patch(this.crmApiPath + 'news/website/delete/' + this.params.data.id, paramsNews)
                .then(() => {
                  this.$snotify.success('News Article Updated on web');

          axios.delete(this.crmApiPath + 'news/' + this.params.data.id)
            .then(() => {
              this.$snotify.success('News Article Deleted');
              
                  
                  this.$tabs.refresh('/news/all', true);
                  this.$bus.$emit('logs::reload', { action: true });
                  this.$bus.$emit('table::reload', { table: 'all_news', type: 'store' });
                  this.saving = false;
                })
                .catch(error => {
                  console.log(error);
                  this.$snotify.error('Error updating news article');
                  this.saving = false;
                });
              

            })
            .catch(error => {
              console.log(error);
              this.$snotify.error('Error deleting news article');
              this.saving = false;
            });
        }
      }
    }
  },
  data() {
    return {
      news: null,
      loadingMessage: 'Loading All News...',
      noRowsMessage: 'No News Found',
      columns: [
        { headerName: 'Title', field: 'title', minWidth: 100 },
        { headerName: 'Author', field: 'author_name', minWidth: 160 },
        { headerName: 'Created', valueGetter: this.created_at_value_getter, minWidth: 110 },
        { headerName: 'Submitted for Auth', field: 'published', minWidth: 160, cellRendererFramework: 'publishedComponent' },
        { headerName: 'Authorise', field: 'authorised', minWidth: 160, cellRendererFramework: 'authorisedComponent' },
        { headerName: '', minWidth: 100, maxWidth: 120, filter: false, cellRendererFramework: 'viewComponent' }, // Add viewComponent
        { headerName: '', minWidth: 100, maxWidth: 120, filter: false, cellRendererFramework: 'editComponent' },
        { headerName: '', minWidth: 100, maxWidth: 120, filter: false, cellRendererFramework: 'deleteComponent' },
      ],

    }
  },
  mounted() {
    this.get_news();
  },
  methods: {
    created_at_value_getter(params) {
      return this.$options.filters.formatDateTime(params.data.created_at);
    },
    get_news() {
      axios.get(this.crmApiPath + 'news/all/index').then(news => this.news = news.data);
    }
  },
}
</script>
